// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProductPurchasedPerMonthBanner{background:#fdfcbf;color:#ed3d3d;font-weight:700;padding:.5rem .75rem}.ProductPurchasedPerMonthBanner .row{gap:.75rem}.ProductPurchasedPerMonthBanner__icon{color:#ed3d3d}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
